import React from 'react';
import { getCurrentYear } from 'common-react';
import { PensionProductCode, ProductCode } from 'funds-model';
import Decimal from 'decimal.js';
import { formatNumber } from '../utils/formatters';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography/Typography';
import { TypographyModel } from '../Typography/tools/Typography.model';
import { useIsMobile } from '../utils/useIsMobile';

interface PensionCardTooltipContentProps {
  productCode: ProductCode | PensionProductCode;
  yearlyPayments: Decimal;
  IKZEEntrepreneurLimit: number;
  IKZEStandardLimit: number;
  currentLimits: {
    IKE: number;
    IKZE: number;
  };
}

export const PensionCardTooltipContent = ({
  productCode,
  yearlyPayments,
  IKZEEntrepreneurLimit,
  IKZEStandardLimit,
  currentLimits,
}: PensionCardTooltipContentProps) => {
  const [t] = useTranslation('components');
  const currentYear = getCurrentYear();
  const isIke = productCode === ProductCode.ike;
  const isMobile = useIsMobile();
  const typographyProps = { variant: 'body2', textColor: isMobile ? 'greys.80' :'greys.0'} as TypographyModel;

  return (<>
    <Typography {...typographyProps} fontWeight="bold">
      {t("savings-progress-bar.box.deposit_limit_tooltip_title", {
        productType: productCode.toUpperCase(),
        currentYear,
      })}
    </Typography>
    <Typography {...typographyProps}>
      {isIke
        ? t("savings-progress-bar.box.deposit_limit_tooltip_ike_description", {
            limit: formatNumber(new Decimal(currentLimits.IKE)),
          })
        : t("savings-progress-bar.box.deposit_limit_tooltip_ikze_description", {
            limit: formatNumber(new Decimal(IKZEStandardLimit)),
            entrepreneurLimit: formatNumber(new Decimal(IKZEEntrepreneurLimit)),
          })}
    </Typography>
    <br />
    <Typography {...typographyProps}>
      {t("savings-progress-bar.box.deposit_tooltip_description", {
        productType: productCode.toUpperCase(),
        value: formatNumber(yearlyPayments),
      })}
    </Typography>
  </>);
};
